export function scrollIntoView(index, element) {
    if (!element.parentElement) {
        return;
    }
    if (index === 0) {
        element.parentElement.scrollTop = 0;
        return;
    }
    var offsetTop = element.offsetTop, clientHeight = element.clientHeight;
    var _a = element.parentElement, scrollTop = _a.scrollTop, parentHeight = _a.clientHeight;
    if (offsetTop < scrollTop) {
        element.parentElement.scrollTop = offsetTop;
    }
    else if (offsetTop + clientHeight > scrollTop + parentHeight) {
        element.parentElement.scrollTop = offsetTop - parentHeight + clientHeight;
    }
}
//# sourceMappingURL=scrollIntoView.js.map